/**
 * Phase 6 — Marketplace + Lead-facing trust block.
 * MarketplaceRatingBadge: minimal pill rendered inline by Marketplace cards.
 * HelperTrustBlock: never rendered for Client surfaces (Client never sees
 * trust per §6.3.3).
 */
import React from "react";
import { TID } from "@/lib/testIds";


export function MarketplaceRatingBadge({ ratingAvg, ratingCount }) {
  if (ratingCount === undefined || ratingCount === null) return null;
  return (
    <span className="avcp-pill" data-testid={TID.mpRatingBadge}>
      {ratingAvg != null ? (
        <>★ {ratingAvg.toFixed(1)} · {ratingCount}</>
      ) : (
        <>{ratingCount} rating{ratingCount === 1 ? "" : "s"} · avg pending</>
      )}
    </span>
  );
}


export function HelperTrustBlock({ trust }) {
  if (!trust) return null;
  const items = [
    ["Rating", trust.rating_avg != null
                  ? `★ ${trust.rating_avg.toFixed(1)} (${trust.rating_count})`
                  : (trust.rating_count > 0
                       ? `${trust.rating_count} rating${trust.rating_count === 1 ? "" : "s"} · avg pending`
                       : "no ratings yet")],
    ["Completed jobs", trust.jobs_completed_count ?? 0],
    ["Reliability", trust.reliability_score != null
                       ? `${Math.round(trust.reliability_score * 100)}%` : "—"],
    ["No-shows", trust.no_show_count ?? 0],
    ["Late withdrawals", trust.late_withdraw_count ?? 0],
  ];
  return (
    <div className="text-xs text-[var(--avcp-ink-soft)] mt-2 flex gap-3 flex-wrap"
         data-testid={TID.helperTrustBlock}>
      {items.map(([label, value]) => (
        <span key={label}>
          <span className="text-[var(--avcp-ink-soft)]">{label}: </span>
          <span className="font-medium">{String(value)}</span>
        </span>
      ))}
    </div>
  );
}
